// action - account reducer firebase
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";

// action admin - Login in MERN
export const LOGIN_2FA = "LOGIN_2FA";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const ADMIN_LOADED = "ADMIN_LOADED";
export const AUTH_FAIL = "AUTH_FAIL";

export const SET_ALERT = "SET_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const DELETE_ALL_ALERT = "DELETE_ALL_ALERT";

export const GET_ALL_PROJECT = "GET_ALL_PROJECT"
export const GET_PROJECT_DETAIL = "GET_PROJECT_DETAIL"
export const REMOVE_PROJECT_DETAIL = "REMOVE_PROJECT_DETAIL"
export const GET_ALL_DROPDOWN = "GET_ALL_DROPDOWN"
export const GET_CLIENT_DROPDOWN = "GET_CLIENT_DROPDOWN"
export const GET_BUDGET_DETAILS = "GET_BUDGET_DETAILS"

export const GET_ALL_PORTFOLIO = "GET_ALL_PORTFOLIO"
export const GET_PORTFOLIO_DETAIL = "GET_PORTFOLIO_DETAIL"
export const GET_IMAGE_URL = "GET_IMAGE_URL"
export const REMOVE_PORTFOLIO_DETAILS = "REMOVE_PORTFOLIO_DETAILS" 


export const SET_PAGE = "SET_PAGE"
export const SET_LOADING = "SET_LOADING"

export const UPDATE_PROJECT_STATUS_OPTIMISTIC = 'UPDATE_PROJECT_STATUS_OPTIMISTIC';
export const ROLLBACK_PROJECT_STATUS = 'ROLLBACK_PROJECT_STATUS';
export const OPTIMISTIC_UPDATE_PAYMENT_DELETION = "OPTIMISTIC_UPDATE_PAYMENT_DELETION"
export const ROLLBACK_PAYMENT_DELETION = "ROLLBACK_PAYMENT_DELETION"



